import { useMenu } from '@entities/Menu'

import type { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { ProductGroupMenu } from '@widgets/product-group-menu'

type MenuBlockPayload = {
  code: string;
}

export default function MenuBlock ({ payload }: BlockProps) {
  const code = (payload as MenuBlockPayload | null)?.code

  const { menu, loading, error } = useMenu({ code: code ?? '' })

  if (!code || loading || error || !menu?.menuItems?.length) {
    return null
  }

  return (
    <div className={styles.root__menu}>
      <ProductGroupMenu className="" />
    </div>
  )
}
